import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {AccountInterfaceData} from "../shared/models/account.model";
import {ClickFunnelPostInterfaceData} from "./integrations-clickfunnels/integrations-clickfunnels.component";
import {GoogleadsPostInterfaceData} from "./integrations-googleads/integrations-googleads.component";
import {FacebookPostInterfaceData} from "./integration-facebook/integration-facebook.component";
import {ShopifyPostInterfaceData} from "./integrations-shopify/integrations-shopify.component";

@Injectable({providedIn: 'root'})
export class IntegrationProviderService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  // getAccounts(endpoint: string){
  //   //{ headers: headers, params: params }
  //   let url = `${this.url}/${endpoint}`;
  //   return this.http.get< AccountInterfaceData[]>(url);
  //   // {observe: 'response'} main.js:1 ERROR TypeError: t.payload is not iterable
  // } //end login

  post_shopify(endpoint: string, shopify: ShopifyPostInterfaceData) {
    return this.http.post(`${this.url}/${endpoint}`, shopify,{observe: 'response'});
  }

  patch_shopify(endpoint: string, shopify: ShopifyPostInterfaceData) {
    return this.http.patch(`${this.url}/${endpoint}`, shopify,{observe: 'response'});
  }

  post_clickfunnels(endpoint: string, clickfunnels: ClickFunnelPostInterfaceData) {
    return this.http.post(`${this.url}/${endpoint}`, clickfunnels,{observe: 'response'});
  }

  post_googleads(endpoint: string, googleads: GoogleadsPostInterfaceData) {
    return this.http.post(`${this.url}/${endpoint}`, googleads,{observe: 'response'});
  }

  post_facebook(endpoint: string, facebook: FacebookPostInterfaceData) {
    return this.http.post(`${this.url}/${endpoint}`, facebook,{observe: 'response'});
  }

  get(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.get(url,{observe: 'response'});
  } //end login

  delete(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.delete(url,{observe: 'response'});
  } //end delete




} // end class


